import { zipSync, strToU8 } from "fflate";
import buildAcrFileContent from "./buildAcrFileContent";

/** Append -1, -2, … before the extension so ACRs with identical filenames don't overwrite in the zip. */
function dedupeFilename(filename, usedNames) {
  if (!usedNames.has(filename)) {
    return filename;
  }
  const dot = filename.lastIndexOf(".");
  const stem = dot === -1 ? filename : filename.slice(0, dot);
  const ext = dot === -1 ? "" : filename.slice(dot);
  let counter = 1;
  let candidate = `${stem}-${counter}${ext}`;
  while (usedNames.has(candidate)) {
    counter += 1;
    candidate = `${stem}-${counter}${ext}`;
  }
  return candidate;
}

/**
 * Bundle multiple ACRs into a single compressed .zip and download it. `items` is a list of
 * { evaluation, catalog }; each is serialized to `fileType` (html | json | yaml) via the shared
 * content builder, then DEFLATE-compressed into one archive (text ACRs compress well).
 * Returns the number of files written so callers can report progress/results.
 */
export default function downloadAcrZip(items, fileType, zipName = "acr-export") {
  const usedNames = new Set();
  const files = {};

  items.forEach(({ evaluation, catalog }) => {
    const { filename, content } = buildAcrFileContent(evaluation, catalog, fileType);
    const name = dedupeFilename(filename, usedNames);
    usedNames.add(name);
    files[name] = strToU8(content);
  });

  const zipped = zipSync(files, { level: 6 });
  // fflate returns a view into a larger buffer; copy the exact bytes so the Blob isn't padded.
  const bytes = zipped.slice();
  const blob = new Blob([bytes], { type: "application/zip" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = `${zipName}.zip`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);

  return Object.keys(files).length;
}
